var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#ECB576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.67-664h594.66v-88H182.67v88Zm0 0v-88 88Zm0 604q-33.73 0-58.87-25.14Q98.67-110.27 98.67-144v-608q0-33.73 25.13-58.86Q148.94-836 182.67-836H218v-64h87.33v64h349.34v-64H742v64h35.33q33.73 0 58.87 25.14 25.13 25.13 25.13 58.86v264.33q-19.78-9.19-40.89-14.26t-43.11-6.74V-580H182.67v436h304.66q7.34 23 18.67 44.33Q517.33-78.33 532.67-60h-350ZM750-21.33q-88.24 0-149.79-61.55-61.54-61.54-61.54-149.79 0-88.24 61.54-149.78Q661.76-444 750-444t149.79 61.55q61.54 61.54 61.54 149.78 0 88.25-61.54 149.79Q838.24-21.33 750-21.33Zm60.83-109.34 30.5-30.66-76-75.34v-128H722v144l88.83 90Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDoneIcon);
export default __webpack_public_path__ + "static/media/not-done-icon.7a2c8f33f1964535f801b8e97258b79d.svg";
export { ForwardRef as ReactComponent };